import React from 'react';


const SessionStats = ({ stats, totalVehicles = 0, isScanning = false }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        Estadísticas de la Sesión
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {/* Total Detected in Session */}
        <div className="text-center p-4 rounded-lg bg-green-50 border border-green-200">
          <div className="text-2xl font-bold text-green-700">
            {stats?.totalDetected || 0}
          </div>
          <p className="text-sm text-green-600 mt-1">
            {isScanning ? 'Detectados' : 'Nuevos Detectados'}
          </p>
        </div>

        {/* Total Scans Performed {stats?.totalScans || 0} */}
        <div className="text-center p-4 rounded-lg bg-blue-50 border border-blue-200">
          <div className="text-2xl font-bold text-blue-700">
            -
          </div>
          <p className="text-sm text-blue-600 mt-1">
            Consultas Reader
          </p>
        </div>

        {/* Active Session Time */}
        <div className="text-center p-4 rounded-lg bg-purple-50 border border-purple-200">
          <div className="text-2xl font-bold text-purple-700">
            {stats?.activeTime || '00:00:00'}
          </div>
          <p className="text-sm text-purple-600 mt-1">
            Tiempo Activo
          </p>
        </div>

        {/* Total Vehicles in System */}
        <div className="text-center p-4 rounded-lg bg-orange-50 border border-orange-200">
          <div className="text-2xl font-bold text-orange-700">
            {totalVehicles}
          </div>
          <p className="text-sm text-orange-600 mt-1">
            Total en Sistema
          </p>
        </div>
      </div>
      {/* Last Update */}
      {stats?.lastUpdate && (
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Última actualización: {new Date(stats.lastUpdate)?.toLocaleString('es-ES', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            })}
          </p>
        </div>
      )}
    </div>
  );
};

export default SessionStats;